import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

// JS Files
import Navbar from "../../shares/Navbar";
import Footer from "../../shares/Footer";
import GuideSteps from "./GuideSteps";
import OtpForm from "./OtpForm";
import MuiButton from "../../shares/MuiButton";
import { useAuth } from "../../../context/AuthContext";
import { activeTakmiliSignup } from "../../../constants/constants";
import Waiting from "./Waiting";

// Others File

const SignupTakmili = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState("/step-one");
  return (
    <>
      <div className="hp-section-one">
        <Navbar activePage="aboutus" />
      </div>
      <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
        <p className="header">ثبت‌نام بیمه درمان تکمیلی</p>
        <div className="border rounded-lg mt-8 border-mygray-300 py-4 md:py-8 px-4 grid md:grid-cols-7 gap-4">
          <GuideSteps />
          {activeTakmiliSignup == false ? (
            <Waiting isSoon  text="ثبت‌نام الکترونیکی بیمه درمان تکمیلی به زودی فعال خواهد گردید."/>
          ) : token == null ? (
            <OtpForm />
          ) : (
            <div className="md:col-span-3 flex justify-center items-center">
              <MuiButton
                onClick={() => navigate(step)}
                type="submit"
                variant="contained"
                color="primary"
                text="تایید و ادامه"
                size="large"
                icon={<ArrowBackIcon />}
              />
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};
export default SignupTakmili;
